export default "__VITE_ASSET__41ea238b__"